module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    ref: "item",
    staticClass: "vue-grid-layout",
    style: (_vm.mergedStyle)
  }, [(_vm.$slots['grid-header']) ? _c('div', {
    staticClass: "vue-grid-header"
  }, [_vm._t("grid-header")], 2) : _vm._e(), _vm._v(" "), _vm._t("default")], 2), _vm._v(" "), (_vm.modalConfig.model && _vm.modalConfig.schema) ? _c('modal', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isModalVisible),
      expression: "isModalVisible"
    }],
    attrs: {
      "is-modal-visible": _vm.isModalVisible,
      "facet-id": _vm.modalConfig.facetId,
      "expanding": _vm.modalConfig.expanding,
      "model": _vm.modalConfig.model,
      "schema": _vm.modalConfig.schema
    },
    on: {
      "close": _vm.closeModal
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-862fdcc8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/GridLayout.vue
// module id = 78
// module chunks = 0